import { convertToFloat, formateAmount } from '@/utilz';
import Paper from '@/views/components/Paper/Paper';
import FooterContentCard from '@/views/screens/common/FooterContentCard';
import { Col, Divider, Row } from 'antd';
import { cloneDeep, maxBy } from 'es-toolkit';
import { useMemo } from 'react';
import Button from '../../../../../components/Buttons/Button';
import PrimaryLabel from '../../../../../components/Labels/PrimaryLabel';
import OverChargeSettlementCard from '../../Components/Edit/Components/OverChargeSettlements/OverChargeSettlementCard';

const CreateOverChargeSettlements = ({ settlementList = [], setSettlementList }) => {
  const setEditMode = (index, val) => {
    const settlementListLocal = cloneDeep(settlementList);
    settlementListLocal[index].editMode = val;
    setSettlementList(settlementListLocal);
  };

  const handleCancel = (index, isNew) => () => {
    const settlementListLocal = cloneDeep(settlementList);
    if (isNew) {
      settlementListLocal.splice(index, 1);
    } else {
      settlementListLocal[index] = {
        ...settlementListLocal[index],
        editMode: false,
        isNew: false,
      };
    }
    setSettlementList(settlementListLocal);
  };

  const handleSubmit = (data, index) => {
    const settlementListLocal = cloneDeep(settlementList);
    settlementListLocal[index] = { ...data, editMode: false, isNew: false };
    setSettlementList(settlementListLocal);
  };

  const handleDelete = (index) => () => {
    const settlementListLocal = cloneDeep(settlementList);
    settlementListLocal.splice(index, 1);
    setSettlementList(settlementListLocal);
  };

  const handleAddNew = () => () => {
    let settlementListLocal = cloneDeep(settlementList);
    let nextSequence = maxBy(settlementListLocal, ({ settlementSeq }) => Number(settlementSeq));
    nextSequence = nextSequence ? nextSequence.settlementSeq : 0;
    settlementListLocal = [
      {
        fbocKey: 0,
        settlementSeq: nextSequence + 1,
        accountingCode: undefined,
        amount: convertToFloat(0),
        dirtyFlag: 'i',
        isNew: true,
        editMode: true,
      },
      ...settlementListLocal,
    ];
    setSettlementList(settlementListLocal);
  };

  const totalAmount = useMemo(
    () => settlementList.reduce((acc, item) => acc + Number(item.amount), 0),
    [settlementList],
  );

  return (
    <div>
      <Row className="align-items-center" justify="space-between">
        <Col>
          <PrimaryLabel className="fw-700 f-18">Overcharge Claims Settlements</PrimaryLabel>
        </Col>
        <Col>
          <Row justify="end" gutter={16}>
            <Col>
              <Button onClick={handleAddNew()}>Add New Settlement</Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider className="mt-0 my-16 ml-n16 vw-100 " />
      <div className="flex-1 custom-scroll-bar">
        <div className="">
          {settlementList.map((row, index) => (
            <OverChargeSettlementCard
              settlementDetails={row}
              key={row.settlementSeq}
              index={index}
              editMode={Boolean(row.editMode)}
              setEditMode={setEditMode}
              handleCancel={handleCancel}
              handleSubmit={handleSubmit}
              handleDelete={handleDelete}
            />
          ))}
        </div>
      </div>

      <div className="mt-20">
        <Paper className="background-header px-30 py-5">
          <Row justify="space-around" className="px-10" gutter={10}>
            <Col sm={8} />
            <Col sm={8}>
              <FooterContentCard
                align="middle"
                justify="start"
                count={formateAmount(totalAmount)}
                label="Total Amount"
                contentClass="text-white f-16 fw-600"
                labelClass="text-light f-14"
              />
            </Col>
            <Col sm={8} />
          </Row>
        </Paper>
      </div>
    </div>
  );
};

export default CreateOverChargeSettlements;
